import { useState } from "react";
import { Star } from "lucide-react";

export function StarRating({ value = 0, onChange, readOnly = false, size = 18, testId = "star-rating" }) {
    const [hover, setHover] = useState(0);
    const display = hover || value;
    return (
        <div className="flex items-center gap-0.5" data-testid={testId}>
            {[1, 2, 3, 4, 5].map((n) => (
                <button
                    key={n}
                    type="button"
                    disabled={readOnly}
                    onMouseEnter={() => !readOnly && setHover(n)}
                    onMouseLeave={() => !readOnly && setHover(0)}
                    onClick={() => !readOnly && onChange && onChange(n)}
                    className={`transition-transform ${readOnly ? "cursor-default" : "hover:scale-110 cursor-pointer"}`}
                    aria-label={`${n} star${n > 1 ? "s" : ""}`}
                    data-testid={`${testId}-${n}`}
                >
                    <Star
                        width={size}
                        height={size}
                        className={n <= display ? "fill-[var(--ok-accent)] text-[var(--ok-accent)]" : "text-[var(--ok-text-muted)]"}
                    />
                </button>
            ))}
        </div>
    );
}
